export default __webpack_public_path__ + "fonts/pt-sans-v11-latin-700.woff";